var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{style:(_vm.progressVars)},_vm._l((_vm.products),function(product,index){return _c('li',{key:product.type,class:{ selected: index <= _vm.currentProductIndex }},[_c('img',{attrs:{"src":product.icon,"alt":product.label}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }